import { render } from "./GymNavBar.vue?vue&type=template&id=65e343f7&scoped=true"
import script from "./GymNavBar.vue?vue&type=script&lang=js"
export * from "./GymNavBar.vue?vue&type=script&lang=js"

import "./GymNavBar.vue?vue&type=style&index=0&id=65e343f7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e343f7"]])

export default __exports__